var React = require('react');

function IcFilters (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13,20v-4.586L20.414,8C20.789,7.625,21,7.116,21,6.585V4c0-0.553-0.447-1-1-1H4C3.447,3,3,3.447,3,4v2.585 C3,7.116,3.211,7.625,3.586,8L11,15.414V22L13,20z"}));
}

IcFilters.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = IcFilters;

IcFilters.default = IcFilters;
